import React, { Fragment, useEffect, useState } from 'react';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { wsGet } from 'services/WService';
import { wsCreate } from 'services/WService';
import {
  RetentionDataBureaus,
  RetentionDataGeneral,
  RetentionDataRestrictions,
  RetentionDataRules,
} from './RetentionDataFragment';

const states = [
  { value: 'D', text: 'Actualización solicitada' },
  { value: 'U', text: 'Actualización aprobada' },
  { value: 'X', text: 'Por aprobar' },
  { value: 'A', text: 'Aprobado' },
  { value: 'C', text: 'Anulado' },
];

function PromotionRetentionModal(props) {
  const { model, setOpen, refreshRetentions } = props;
  const [loading, setLoading] = useState(false);
  const [retention, setRetention] = useState();
  const [currentData, setCurrentData] = useState();
  const [retentionData, setRetentionData] = useState();

  async function getData() {
    setLoading(true);
    setRetention(undefined);
    setRetentionData(undefined);
    let res = await wsGet('prom/retention', model.id);
    setLoading(false);
    if (res.success) {
      setRetention(res.data);
      setRetentionData(res.data.data);
      setCurrentData(res.data.current_promotion_data);
    }
  }

  async function approve() {
    if (retention === undefined) return;
    setLoading(true);
    let res = await wsCreate(`prom/retention/${retention.id}/approve`);
    setLoading(false);
    if (res.success) {
      setRetention(undefined);
      setRetentionData(undefined);
      setOpen({ open: false });
      refreshRetentions();
    }
  }

  async function cancel() {
    if (retention === undefined) return;
    setLoading(true);
    let res = await wsCreate(`prom/retention/${retention.id}/cancel`);
    setLoading(false);
    if (res.success) {
      setRetention(undefined);
      setRetentionData(undefined);
      setOpen({ open: false });
      refreshRetentions();
    }
  }

  useEffect(() => {
    if (model === undefined || model.id === undefined) return;
    getData();
  }, [model]);

  return (
    <Modal
      title={retention?.promotion?.description || 'Cargando promoción...'}
      model={model}
      setOpen={setOpen}
      hideSave
      hideClose
      disabledSave
      maxWidth="lg"
      fullWidth
      entity=""
    >
      <GridContainer
        style={{
          minHeight: '500px',
          maxHeight: '650px',
          overflow: 'auto',
        }}
      >
        {retention !== undefined && (
          <Fragment>
            <GridItem xs={12}>
              <GridContainer>
                <GridItem xs={3}>
                  <h6>Id</h6>
                  <p>{currentData?.id}</p>
                </GridItem>
                <GridItem xs={3}>
                  <h6>Estado</h6>
                  <p>
                    {states.find((state) => state.value === retention.state)?.text ||
                      retention.state}
                  </p>
                </GridItem>
              </GridContainer>
            </GridItem>
            <GridItem xs={12}>
              <RegularButton color="success" size="sm" disabled={loading} onClick={approve}>
                Aprobar actualización
              </RegularButton>
              <RegularButton color="danger" size="sm" disabled={loading} onClick={cancel}>
                Anular cambios
              </RegularButton>
            </GridItem>
          </Fragment>
        )}

        {retentionData !== undefined && currentData !== undefined && (
          <RetentionData retentionData={retentionData} anotherData={currentData} />
        )}
      </GridContainer>
    </Modal>
  );
}

function RetentionData(props) {
  const { retentionData, anotherData } = props;
  return (
    <GridItem xs={12}>
      {/* General */}
      <GridContainer>
        <GridItem xs={6}>
          <RetentionDataGeneral retentionData={retentionData} anotherData={anotherData} />
        </GridItem>
        <GridItem xs={6}>
          <RetentionDataGeneral retentionData={anotherData} anotherData={retentionData} />
        </GridItem>
      </GridContainer>
      {/* Reglas */}
      <GridContainer>
        <GridItem xs={6}>
          <RetentionDataRules retentionData={retentionData} anotherData={anotherData} />
        </GridItem>
        <GridItem xs={6}>
          <RetentionDataRules retentionData={anotherData} anotherData={retentionData} />
        </GridItem>
      </GridContainer>
      {/* Restricciones */}
      <GridContainer>
        <GridItem xs={6}>
          <RetentionDataRestrictions retentionData={retentionData} anotherData={anotherData} />
        </GridItem>
        <GridItem xs={6}>
          <RetentionDataRestrictions retentionData={anotherData} anotherData={retentionData} />
        </GridItem>
      </GridContainer>
      {/* Mesas */}
      <GridContainer>
        <GridItem xs={6}>
          <RetentionDataBureaus retentionData={retentionData} anotherData={anotherData} />
        </GridItem>
        <GridItem xs={6}>
          <RetentionDataBureaus retentionData={anotherData} anotherData={retentionData} />
        </GridItem>
      </GridContainer>
    </GridItem>
  );
}

export default PromotionRetentionModal;
